var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.8125C8.78125 7.8125 7.8125 8.8125 7.8125 10C7.8125 11.2188 8.8125 12.1875 10 12.1875C11.2188 12.1875 12.1875 11.1875 12.1875 10C12.1875 8.78125 11.2188 7.8125 10 7.8125ZM10 11.0938C9.40625 11.0938 8.90625 10.5938 8.90625 10C8.90625 9.40625 9.40625 8.90625 10 8.90625C10.5938 8.90625 11.0938 9.40625 11.0938 10C11.0938 10.5938 10.5938 11.0938 10 11.0938Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4062 7.8125C16.1875 7.8125 15.2188 8.8125 15.2188 10C15.2188 11.2188 16.2188 12.1875 17.4062 12.1875C18.625 12.1875 19.5938 11.1875 19.5938 10C19.625 8.78125 18.625 7.8125 17.4062 7.8125ZM17.4062 11.0938C16.8125 11.0938 16.3125 10.5938 16.3125 10C16.3125 9.40625 16.8125 8.90625 17.4062 8.90625C18 8.90625 18.5 9.40625 18.5 10C18.5 10.5938 18.0312 11.0938 17.4062 11.0938Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.59375 7.8125C1.375 7.8125 0.40625 8.8125 0.40625 10C0.40625 11.2188 1.40625 12.1875 2.59375 12.1875C3.8125 12.1875 4.78125 11.1875 4.78125 10C4.78125 8.78125 3.78125 7.8125 2.59375 7.8125ZM2.59375 11.0938C2 11.0938 1.5 10.5938 1.5 10C1.5 9.40625 2 8.90625 2.59375 8.90625C3.1875 8.90625 3.6875 9.40625 3.6875 10C3.6875 10.5938 3.1875 11.0938 2.59375 11.0938Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.f24ddb4ba57c281041082b5444043adc.svg";
export { ForwardRef as ReactComponent };